const { REQUEST_ERROR_CODES } = require("../../constants");

class ApplicationError extends Error {
  constructor(
    message,
    status = 500,
    axiosError = null,
    axiosErrorHandlersConfig = {},
    errorDetails
  ) {
    super(message);

    this.status = status;
    this.details = errorDetails;

    // APP-28326: keep a bounded trace of the underlying failure so it
    // survives into the logs and into lead.emails.error instead of being
    // discarded the moment we wrap it.
    if (axiosError) {
      this.cause = axiosError;
      this.originalMessage = axiosError.message;
      this.originalCode = axiosError.code;
      this.originalStatus = axiosError.response?.status;
      this.originalStack = axiosError.stack;
    }

    if (axiosError?.isAxiosError) {
      this.handleAxiosError(axiosError, axiosErrorHandlersConfig);
    }
  }

  handleAxiosError(error, errorHandlersConfig) {
    // APP-28326: a transport-level failure (timeout, ECONNRESET, TLS error)
    // carries no `response`, so reading `error.response.status` below threw a
    // TypeError from inside this constructor. Dormant until now because no
    // caller passed an axios error in - CustomerFirstService now does.
    if (!error.response) {
      return;
    }

    const isResponseCodeInConfig = Object.keys(errorHandlersConfig).includes(
      String(error.response.status)
    );

    if (!isResponseCodeInConfig) {
      return;
    }

    const { status, message } = errorHandlersConfig[error.response.status];

    this.status = status;
    this.message = message;
  }

  getResponseBody() {
    if (this.details) {
      return {
        errorCode: this.message,
        details: this.details,
      };
    }

    if (!Object.values(REQUEST_ERROR_CODES).includes(this.message)) {
      return { errorCode: REQUEST_ERROR_CODES.UNKNOWN_ERROR };
    }

    return { errorCode: this.message };
  }
}

module.exports = ApplicationError;
